import { euro } from "./api";


export const QJ_BESCHIKBAARHEID = {
  leverbaar: { label: "Leverbaar", cls: "bg-[#E10600] text-white" },
  op_voorraad: { label: "Op voorraad", cls: "bg-[#E10600] text-white" },
  op_bestelling: { label: "Op bestelling", cls: "bg-white text-[#0A0A0B]" },
  binnenkort: { label: "Binnenkort", cls: "bg-[#2A2B31] text-white" },
  uitverkocht: { label: "Uitverkocht", cls: "bg-[#1C1D22] text-[#9A9CA3]" },
};

export const qjStatus = (v) => QJ_BESCHIKBAARHEID[v] || QJ_BESCHIKBAARHEID.leverbaar;

export const swatchBg = (k) =>
  k.hex2 ? `linear-gradient(135deg, ${k.hex} 50%, ${k.hex2} 50%)` : k.hex || "#1C1D22";

export const QJ_KEY_SPECS = [
  { key: "cilinderinhoud", label: "Cilinderinhoud" },
  { key: "vermogen", label: "Vermogen" },
  { key: "koppel", label: "Koppel" },
  { key: "gewicht", label: "Gewicht" },
  { key: "zithoogte", label: "Zithoogte" },
  { key: "tankinhoud", label: "Tankinhoud" },
];

export const QJ_BTW = "incl. 21% btw";

export const QJ_CATEGORIES = [
  { slug: "adventure", label: "Adventure", img: "/qj/srt800rx-3.webp" },
  { slug: "custom", label: "Custom", img: "/qj/srv600v-5.webp" },
  { slug: "sport", label: "Sport", img: "/qj/srk800rr-5.webp" },
  { slug: "naked", label: "Naked", img: "/qj/srk800-5.webp" },
];
export const qjCatBySlug = (s) => QJ_CATEGORIES.find((c) => c.slug === s);
export const qjCatByLabel = (l) => QJ_CATEGORIES.find((c) => c.label.toLowerCase() === (l || "").toLowerCase());
export const qjPrijs = (p) => (p === null || p === undefined || p === "" ? "Prijs op aanvraag" : euro(p));

export const QJ_FALLBACK_IMG = "https://images.unsplash.com/photo-1558981403-c5f9899a28bc?w=1600";
